
export function timestampToYMD(timestamp) { // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    if (timestamp.toString().indexOf('-') !== -1) {
        timestamp = timestamp.replace(new RegExp(/-/gm), '/');
    }
    const date = new Date(timestamp);
    const Y = date.getFullYear() + '-';
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    const D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate();
    return Y + M + D;
}

export function timestampToHMS(timestamp) { // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    if (timestamp.toString().indexOf('-') !== -1) {
        timestamp = timestamp.replace(new RegExp(/-/gm), '/');
    }
    const date = new Date(timestamp);
    const Y = date.getFullYear() + '-';
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    const D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
    const h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
    const m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
    const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
}

export function timestampToHM(timestamp) { // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    if (timestamp.toString().indexOf('-') !== -1) {
        timestamp = timestamp.replace(new RegExp(/-/gm), '/');
    }
    const date = new Date(timestamp);
    const Y = date.getFullYear() + '-';
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    const D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
    const h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
    const m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes();
    return Y + M + D + h + m;
}
